import { lazy } from 'react'

export const Feedback = lazy(() => import('./v1/Feedback'))
export const FeedbackV2 = lazy(() => import('./v2/FeedbackV2'))
export const FeedbackV3 = lazy(() => import('./v3/FeedbackV3'))
